import { createAction } from 'typesafe-actions';
import { ITrap } from '../../types/model/trap/trap';

export default class TrapActions {
    public static setLoading = createAction('TRAP_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('TRAP_SET', resolve => (blocks : Array<ITrap>) => resolve(blocks));
}